/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { replace, getLocation } from 'connected-react-router';
import { CHANGE_DATE_REQUEST_STAGES as stages } from 'config/constants';
import { getChangeDatesRequestPageLink } from 'lib/links';

const stageToPath = {
  [stages.EDIT]: '/edit',
  [stages.REVIEW]: '/review',
  [stages.SUBMITTING]: '/submitting',
  [stages.CONFIRMED]: '/confirmed',
};

export const useSyncUrlWithState = ({ bookingId, stage }) => {
  const dispatch = useDispatch();
  const location = useSelector(getLocation);

  useEffect(() => {
    const suffix = stageToPath[stage];
    const path = getChangeDatesRequestPageLink(bookingId, suffix);

    if (path !== location.pathname) {
      dispatch(replace(path));
    }
  }, [bookingId, stage]);
};
